<template>
    <div class="w-100 h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">Subject Moving</h2>
            <p class="tw-italic tw-text-gray-700">Subject Moving Info</p>
        </b-container>

        <hr />

        <b-tabs content-class="mt-3" fill>
            <b-tab title="Started" active>
                <b-table
                    striped
                    selectable
        select-mode="single"
            @row-selected="onRowSelected"
                    :fields="startedFields"
                    :items="started"
                >
                <template v-slot:cell(subject_id)="data">
                    <SubjectLink :subject-id="data.value" />
                </template>
                <template v-slot:cell(old_subject_id)="data">
                    <SubjectLink :subject-id="data.value" />
                </template>
                <template v-slot:cell(reset)="data">
                    <b-button v-if="data.item.id != canceling_id" variant="danger" size="sm" @click="cancelMove(data.item.id)">Cancel</b-button>
                    <b-button v-else variant="danger" size="sm" disabled>Canceling <i class="fas fa-spin fa-spinner"></i></b-button>
                </template>
                </b-table>
            </b-tab>
            <b-tab title="In Progress">
                <b-table
                    striped
                    selectable
        select-mode="single"
            @row-selected="onRowSelected"
                    :fields="inProgressFields"
                    :items="inProgress"
                >
                <template v-slot:cell(subject_id)="data">
                    <SubjectLink :subject-id="data.value" />
                </template>
                <template v-slot:cell(old_subject_id)="data">
                    <SubjectLink :subject-id="data.value" />
                </template>
                </b-table>
            </b-tab>
            <b-tab>
                <template v-slot:title>
          Completed
        </template>
                <b-table
                    striped
                    selectable
        select-mode="single"
            @row-selected="onRowSelected"
                    :fields="completedFields"
                    :items="completed"
                >
                <template v-slot:cell(subject_id)="data">
                    <SubjectLink :subject-id="data.value" />
                </template>
                <template v-slot:cell(old_subject_id)="data">
                    <SubjectLink :subject-id="data.value" />
                </template>
                </b-table>
            </b-tab>
        </b-tabs>

        <b-modal id="modal-1" size="lg" scrollable title="Details">
            <b-table responsive stacked :fields="modal_fields" :items="modal_items"></b-table>
        </b-modal>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
    mixins: [DashboardBaseTemplate],
    data() {
        return {
            startedFields: [
                {key: 'subject_name'},
                {key: 'move_notify_date', label: 'Notified On'},
                {key: 'subject_id'},
                {key: 'move_report', label: 'Reporter'},
                {key: 'telephone_number', label: 'Phone'},
                {key: 'moving_subject_status', label: 'Move Status'},
                {key: 'reset', label: 'Cancel Move'}
            ],
            started: [],
            inProgressFields: [
                {key: 'subject_name'},
                {key: 'move_notify_date', label: 'Submitted On'},
                {key: 'old_subject_id', label: 'Old ID'},
                {key: 'subject_id', label: 'New ID'},
                {key: 'move_report', label: 'Reporter'},
                {key: 'telephone_number', label: 'Phone'},
                {key: 'next_scheduled_date_compound', label: 'Next Compound Visit'},
                {key: 'moving_subject_status', label: 'Move Status'},
            ],
            inProgress: [],
            completedFields: [
                {key: 'subject_name'},
                {key: 'screening_id'},
                {key: 'old_subject_id', label: 'Old ID'},
                {key: 'subject_id', label: 'New ID'},
                {key: 'last_followup_date', label: 'Completed On'},
                {key: 'moving_subject_status', label: 'Move Status'},
            ],
            completed: [],
            modal_items: [],

            modal_fields: [
                {key: 'subject_name'},
                {key: 'screening_id'},
                {key: 'old_subject_id', label: 'Old ID'},
                {key: 'subject_id', label: 'New ID'},
                {key: 'move_notify_date', label: 'Notified On'},
                {key: 'move_report', label: 'Reporter'},
                {key: 'telephone_number', label: 'Phone'},
                {key: 'village'},
                {key: 'last_followup_date', label: 'Completed On'},
                {key: 'moving_subject_status', label: 'Move Status'},
            ],
            canceling_id: null,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.find();
    },
    methods: {
        cancelMove(subject_id) {
            if(!confirm("Are you sure you want to remove this subject movement?")){
                return;
            }
            const that = this;
            that.canceling_id = subject_id;
            const fd = new FormData();
            fd.append('subject_id', subject_id);
            HTTP.post('/kenya/moving-subjects/cancel', fd).then(() => {
                that.started.forEach(element => {
                    if(element.id == subject_id){
                        const index = that.started.indexOf(element);
                        that.started.splice(index, 1);
                    }
                    that.canceling_id = null;
                });
            }).catch(error => {
                HandleErrors.HandleErrors(error);

                that.canceling_id = null;
                });
        },
        find() {
            const that = this;
            HTTP.get(`/kenya/moving-subjects?view=started`)
                .then((response) => {
                    that.started = response.data;
                    console.log(that.started);
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
            HTTP.get(`/kenya/moving-subjects?view=in-progress`)
                .then((response) => {
                    that.inProgress = response.data;
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
            HTTP.get(`/kenya/moving-subjects?view=completed`)
                .then((response) => {
                    that.completed = response.data;
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        onRowSelected(items) {
            let that = this;
            that.modal_items = items;
            this.$bvModal.show("modal-1");
        },
    },
};
</script>
